var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUndo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "evenodd",
  d: "M10.44 6.68a8.5 8.5 0 0 1 3.6.78 8.8 8.8 0 0 1 2.87 2.13 8.75 8.75 0 0 1 1.81 3.11l-1.96.62a6.36 6.36 0 0 0-1.36-2.36 6.7 6.7 0 0 0-2.2-1.62 6.5 6.5 0 0 0-2.76-.6q-1.2 0-2.32.42a6.3 6.3 0 0 0-1.98 1.16l3.04 3h-7.5v-7.5l2.96 3a8.5 8.5 0 0 1 2.64-1.56 8.8 8.8 0 0 1 3.16-.58"
})));
export default SvgUndo;